import * as React from "react";
import type { SVGProps } from "react";
const SvgUptoIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="upto_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M128 128a42.667 42.667 0 0 1 42.667-42.667h682.666a42.667 42.667 0 1 1 0 85.334H170.667A42.667 42.667 0 0 1 128 128zm384 810.667A42.667 42.667 0 0 1 469.333 896V401.664L286.165 584.832a42.667 42.667 0 0 1-60.33-60.33l256-256a42.667 42.667 0 0 1 60.33 0l256 256a42.667 42.667 0 0 1-60.33 60.33L554.667 401.664V896A42.667 42.667 0 0 1 512 938.667z"
    />
  </svg>
);
export default SvgUptoIcon;
